import { MappedClass, MappedProperty, MappedPropertyOptional } from '@h5s/util-object';
import { VatRate } from '../../settings/entities';
import { ZPrinterMeanType } from './z-printer-mean-type';
import { mapNaturaTypeToZPrinterVatType, resolveExpectedVatIndex } from './z-printer-natura-mapping';
import { ZPrinterManufacturer } from './z-printer-paper-manufacturer';
import { ZPrinterVatType } from './z-printer-vat-type';

@MappedClass()
export class ZPrinterFiscalConfigVatIn {
  @MappedProperty()
  index: number;

  @MappedProperty()
  percentage: number;

  @MappedProperty()
  name: string;

  @MappedProperty()
  type: ZPrinterVatType;

  @MappedProperty()
  mean: ZPrinterMeanType;

  @MappedPropertyOptional()
  ateco: string | undefined;

  public fromVatRate(vatRate: VatRate, manufacturer: ZPrinterManufacturer): void {
    // Moltiplicazione in precisione Big.js, conversione a number solo alla fine: il wire format vuole un
    // number semplice (non è una valuta), ma va evitato qualunque arrotondamento in floating point prima
    this.percentage = vatRate.rate.times(100).toNumber();
    this.name = vatRate.description;
    // Se naturaTypeOnZeroVat è definito, mappalo al tipo del registratore di cassa, altrimenti usa il tipo standard "vat"
    this.type = vatRate.naturaTypeOnZeroVat
      ? mapNaturaTypeToZPrinterVatType(vatRate.naturaTypeOnZeroVat)
      : ZPrinterVatType.Vat;

    // sendFiscalConfig() blocca l'invio prima di arrivare qui se l'indice non è calcolabile (cashRegisterCode
    // mancante, o natura non supportata dalla marca collegata): se scatta comunque, meglio fallire in modo
    // esplicito che mandare un indice inventato a una stampante fiscale reale.
    const expectedIndex = resolveExpectedVatIndex(vatRate, manufacturer);
    if (expectedIndex === undefined) {
      throw new Error(
        `[ZPrinterFiscalConfigVatIn] Impossibile calcolare l'indice per l'aliquota '${vatRate.description}' (marca '${manufacturer}')`,
      );
    }
    this.index = expectedIndex;

    this.mean = ZPrinterMeanType.Good;
    // Il DTO REST FiscalConfigVatInDto.ateco è opzionale (undefined), non ammette null: con ignoreUndefined il campo viene
    // semplicemente omesso dal payload se il codice ATECO non è configurato
    this.ateco = vatRate.atecoCode?.code;
  }
}
